import type { IDoctor } from '@app/interfaces/doctor.interface';
import type { IClinic } from '@app/interfaces/clinic.interface';

export const getNewFbSiteDoctors = (clinic: IClinic, clinicDoctors: IDoctor[]): IDoctor[] => {
  const allowedDoctorIds = new Set(
    clinic.fbSites
    ?.filter((site) => site.enabled && site.doctorFeedbackEnabled)
    .flatMap((site) => site.doctors || [])
    .map(({ id }) => id) || []
  );

  const uniqueDoctors = new Map<number, IDoctor>();
  clinicDoctors.forEach((doctor) => {
    if (allowedDoctorIds.has(doctor.id) && !uniqueDoctors.has(doctor.id)) {
      uniqueDoctors.set(doctor.id, doctor);
    }
  });

  return Array.from(uniqueDoctors.values());
};
